// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { StateModel } from "@insite/client-framework/Types/ApiModels";

const accountsUrl = "api/tps/accounts/requestAccount";

export interface CustomAddAccountApiParameter extends ApiParameter {
    isCompanyExist: boolean;
    customerAccountNumber: string;
    recentInvoiceNumber: string;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    role: string;
    companyName: string;
    address: string;
    city: string;
    state: StateModel | undefined;
    postalCode: string;
    contactName?: string;
    fax?: string;
    onSuccess?: (result: CustomAddAccountApiParameter) => void;
    onError?: (error: string) => void;
}

export async function customAddAccountService(parameter: CustomAddAccountApiParameter): Promise<ServiceResult<{}>> {
    try {
        const accountModel = await post<CustomAddAccountApiParameter>(
            `${accountsUrl}`,
            parameter as CustomAddAccountApiParameter,
        );
        return {
            result: accountModel,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
